import React, { Fragment } from 'react';
import { translate } from '../../../Services/translation';
import Slider from "react-slick";

const handleDragStart = (e) => e.preventDefault();

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className='videoBlock__carousel-next' onClick={onClick}>
            <span></span>
        </div>
    );
}
const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className='videoBlock__carousel-prev' onClick={onClick}>
            <span></span>
        </div>
    );
}

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 5000,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1.25,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
};


const VideoBlock = (props) => {
    const block = props.result.find(x => x.blockId === props.blockId);
    const getVideoArticle = (video) => {
        const result = [];
        video.sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
        video.forEach(x => {
            if (block.linkUrl + x.videoId !== window.location.pathname) {
                const date = new Date(x.publishedAt);
                const formattedDate = date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, '0') + "-" + date.getDate().toString().padStart(2, '0');
                result.push(
                    <a key={block.linkUrl + x.videoId} href={block.linkUrl + x.videoId} className='videoBlock__carousel-item'>
                        <div className='videoBlock__carousel-item--image'>
                            <img src={x.thumbnail.url} alt={x.title} onDragStart={handleDragStart} role="presentation" />
                        </div>
                        <div className='videoBlock__carousel-item--textContainer'>
                            {x.title && <h4 className='videoBlock__carousel-item--title'>{x.title}</h4>}
                            {x.description && <p className='videoBlock__carousel-item--subtitle' dangerouslySetInnerHTML={{ __html: x.description }}></p>}
                        </div>
                        {formattedDate && formattedDate !== "1-01-01" && <div className='videoBlock__carousel-item--date'>
                            <span></span>
                            <p>{formattedDate}</p>
                        </div>}
                    </a>
                )
            }
        })
        return result;
    }

    return (
        block && block.items?.length > 0 ?
            <div className='grid-system grid-system-within-boundaries'>
                <div className='grid-full-width'>
                    <div className='videoBlock'>
                        <div className='videoBlock__header'>
                            <h3 className='videoBlock__header--title'>{block.title}</h3>
                            <a className='videoBlock__header--seeAll' href={block.linkUrl}>{translate("videos-show-all")}</a>
                        </div>
                        <div className='videoBlock__carousel'>
                            <Slider
                                {...settings}
                            >
                                {getVideoArticle(block.items)}
                            </Slider>
                        </div>
                        <div className='videoBlock__viewAll'>
                            <a href={block.linkUrl}>{translate("videos-show-all")}</a>
                        </div>
                    </div>
                </div>
            </div>
            :
            <Fragment></Fragment>
    )
}
export default VideoBlock;